module.exports = __webpack_public_path__ + "img/message.b9e96851.svg";